<template>
  <div class="msg_item_com">
    <div class="avatar_wrap">
      <avatar :mainColor="left_color" :avatar="avatar"></avatar>
    </div>
    <content-text :mainColor="left_color" :fontColor="fontColor" :content="content"> </content-text>
  </div>
</template>
<script>
import Avatar from './Avatar.vue';
import ContentText from './ContentText.vue';
export default {
  mixins: [],
  props: {
    content: {
      type: String,
      default: ''
    },
    avatar: {
      type: String
    }
  },
  components: {
    avatar: Avatar,
    'content-text': ContentText
  },
  data() {
    return {
      left_color: '#fff',
      fontColor: '#333'
    };
  },
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.msg_item_com {
  padding: 10px 0;
  display: flex;
  .avatar_wrap {
    margin-right: 10px;
  }
}
</style>
